import TableBodyEmptyState from "./TableBodyEmptyState";
import TableBodyLoadingState from "./TableBodyLoadingState";

type Props = {
  children?: React.ReactNode;
  isLoading?: boolean;
  columnAmount: number;
  isEmpty?: boolean;
};

const TableBody = ({ children, isLoading, columnAmount, isEmpty }: Props) => {
  return (
    <tbody className="divide-y divide-faux-ceiling-bright-white dark:divide-gray-700">
      {isLoading ? (
        <TableBodyLoadingState columnAmount={columnAmount} />
      ) : isEmpty ? (
        <TableBodyEmptyState columnAmount={columnAmount} />
      ) : (
        children
      )}
    </tbody>
  );
};

export default TableBody;
